import {ChangeDetectionStrategy, Component, HostBinding, Input, OnInit} from '@angular/core';

@Component({
  selector: 'int-spin-loader',
  templateUrl: './int-spin-loader.component.html',
  styleUrls: ['./int-spin-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IntSpinLoaderComponent implements OnInit {
  @Input() size: number | string = '1em';
  @Input() color!: string;
  @Input() delay = 0;
  outputDelay = 0;

  @HostBinding('style.width')
  @HostBinding('style.height') get _size() {
    return this.isNumber(this.size) ? `${this.size}px` : this.size;
  }
  @HostBinding('style.min-width') get _minWidth() {
    return this._size;
  }
  @HostBinding('style.--int-spin-loader-color') get _color() {
    return this.color;
  }

  isNumber(value: number | string): boolean {
    return !isNaN(+value);
  }

  ngOnInit(): void {
    this.outputDelay = this.delay ?? Math.floor(Math.random() * 100) / 100;
  }

}
